export const addWatermarkToImage = async (file, watermarkText = "GoodbyeCar Brasil") => {
    return new Promise((resolve) => {
        const img = new Image();
        const url = URL.createObjectURL(file);

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            // Desenha a imagem original
            ctx.drawImage(img, 0, 0);

            // Estilo da marca d'água
            const fontSize = canvas.width / 15;
            ctx.font = `${fontSize}px Arial`;
            ctx.fillStyle = 'rgba(0, 255, 242, 0.3)';
            ctx.textAlign = 'center';

            // Marca d'água em diagonal no centro
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(-Math.atan(canvas.height / canvas.width)); // diagonal ~45°
            ctx.fillText(watermarkText, 0, 0);
            ctx.setTransform(1, 0, 0, 1, 0, 0); // Reset

            canvas.toBlob((blob) => {
                URL.revokeObjectURL(url);
                resolve(blob);
            }, 'image/jpeg', 0.6);
        };

        img.src = url;
    });
}